module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"LEGO Checker","short_name":"LEGO Checker","start_url":"/","background_color":"#000000","theme_color":"#000000","display":"standalone","icon":"src/images/lego-logo.png"},
    }]
